import { memo, useEffect, useRef } from 'react';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { gsap } from 'gsap';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const DownIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 8 8" fill="none">
        <path
            d="M4.00469 0.789062V3.98906V7.18906M4.00469 7.18906L0.804688 3.98906M4.00469 7.18906L7.20469 3.98906"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const BannerTips = memo(() => {
    const arrowRef = useRef(null);
    const { t } = useLang('theProduct.BannerA');

    useEffect(() => {
        if (!arrowRef.current) return undefined;

        const tl = gsap.timeline({
            repeat: -1,
            defaults: { ease: 'power2.inOut' },
        });

        tl.set(arrowRef.current, { y: -9, opacity: 0 })
            .to(arrowRef.current, {
                y: 0,
                opacity: 1,
                duration: 0.3, // 20% 阶段
                ease: 'none',
            })
            .to(arrowRef.current, {
                y: 0,
                opacity: 1,
                duration: 0.5, // 50% 阶段
            })
            .to(arrowRef.current, {
                y: 10,
                opacity: 0,
                duration: 0.6, // 30% 阶段
                ease: 'none',
            });

        return () => {
            tl.kill();
        };
    }, []);

    return (
        <div className="banner-tips">
            <div className="banner-tips-text">{t('tips1')}</div>
            <div className={styles['banner-tips-icon']}>
                <div className="icon">
                    <div className="arrow-down" ref={arrowRef}>
                        <DownIcon />
                    </div>
                </div>
            </div>
        </div>
    );
});

BannerTips.displayName = 'BannerTips';

const BannerA = () => {
    const { t } = useLang('theProduct.BannerA');

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751340559371/banner.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1751340559371/banner.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751340559371/banner.jpg',
        label: t('label'),
        labelColor: '#D11504',
        titleColor: '#ffffff',
        descColor: '#ffffff',
        title: t('title'),
        desc: t('desc'),

        childrenB: <BannerTips />,
    };

    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
};

BannerA.displayName = 'BannerA';

export default BannerA;
